import React, { useState, useEffect, useCallback } from "react";
import useEmblaCarousel from "embla-carousel-react";
import {
  SliderWrapper,
  SliderViewport,
  SliderContainer,
  Slide,
  PrevButton,
  NextButton,
  Thumbs,
  ThumbsContainer,
  ThumbsSlide,
  ThumbsSlideNumber,
  ThumbsViewport,
} from "../../../../style/Customizing/CustomizingProducts/ImageSliderStyle";
import Image from "next/image";

const options = {
  loop: true,
  align: "center",
};

const ImageSlider = ({ slides = [] }) => {
  // 현재 선택된 슬라이드의 인덱스 상태
  const [selectedIndex, setSelectedIndex] = useState(0);

  // 메인 슬라이더와 썸네일 슬라이더의 참조 및 API 가져오기
  const [mainRef, mainApi] = useEmblaCarousel(options);
  const [thumbsRef, thumbsApi] = useEmblaCarousel({
    containScroll: "keepSnaps",
    dragFree: true,
  });
  // 이전/다음 버튼 활성화 상태 관리
  const [prevBtnEnabled, setPrevBtnEnabled] = useState(false);
  const [nextBtnEnabled, setNextBtnEnabled] = useState(false);

  // 이전 슬라이드로 이동하는 함수
  const scrollPrev = useCallback(() => {
    if (!mainApi) return;
    mainApi.scrollPrev();
  }, [mainApi]);
  // 다음 슬라이드로 이동하는 함수
  const scrollNext = useCallback(() => {
    if (!mainApi) return;
    mainApi.scrollNext();
  }, [mainApi]);

  // 썸네일 클릭 시 해당 슬라이드로 이동하는 함수
  const onThumbClick = useCallback(
    (index) => {
      if (!mainApi || !thumbsApi) return;
      mainApi.scrollTo(index);
    },
    [mainApi, thumbsApi]
  );

  // 현재 선택된 슬라이드 상태를 업데이트하는 함수
  const onSelect = useCallback(() => {
    if (!mainApi || !thumbsApi) return;
    setSelectedIndex(mainApi.selectedScrollSnap()); // 현재 선택된 슬라이드 인덱스 설정
    thumbsApi.scrollTo(mainApi.selectedScrollSnap()); // 썸네일도 같은 위치로 스크롤
    setPrevBtnEnabled(mainApi.canScrollPrev()); // 이전 버튼 활성화 여부 설정
    setNextBtnEnabled(mainApi.canScrollNext()); // 다음 버튼 활성화 여부 설정
  }, [mainApi, thumbsApi]);

  // 슬라이더가 초기화되거나 선택된 슬라이드가 변경될 때 onSelect 실행
  useEffect(() => {
    if (!mainApi) return;
    onSelect();
    mainApi.on("select", onSelect).on("reInit", onSelect);
  }, [mainApi, onSelect]);

  return (
    <SliderWrapper>
      <SliderViewport ref={mainRef}>
        <SliderContainer>
          {slides.map((item, index) => (
            <Slide key={`${index}_sliderMainImage`}>
              <Image
                src={item.url}
                alt={`${index + 1}_sliderMainImage`}
                width={390}
                height={390}
                style={{
                  width: "100%",
                  maxWidth: "90%",
                  height: "auto",
                  objectFit: "contain",
                  margin: "0 auto",
                }}
              />
            </Slide>
          ))}
        </SliderContainer>
      </SliderViewport>

      <PrevButton onClick={scrollPrev} disabled={!prevBtnEnabled} type="button">
        <i className="fi-rs-angle-left" />
      </PrevButton>
      <NextButton onClick={scrollNext} disabled={!nextBtnEnabled} type="button">
        <i className="fi-rs-angle-right" />
      </NextButton>

      <Thumbs>
        <ThumbsViewport ref={thumbsRef}>
          <ThumbsContainer>
            {slides.map((item, index) => (
              <ThumbsSlide key={`${index}_sliderImage`}>
                <ThumbsSlideNumber
                  onClick={() => onThumbClick(index)}
                  selected={index === selectedIndex}
                  type="button"
                >
                  <Image
                    src={item.url}
                    alt={`${index + 1}_sliderImage`}
                    width={55}
                    height={50}
                  />
                </ThumbsSlideNumber>
              </ThumbsSlide>
            ))}
          </ThumbsContainer>
        </ThumbsViewport>
      </Thumbs>
    </SliderWrapper>
  );
};
export default ImageSlider;
